import { render, staticRenderFns } from "./intimateRule.vue?vue&type=template&id=89a77b68&scoped=true"
import script from "./intimateRule.vue?vue&type=script&lang=js"
export * from "./intimateRule.vue?vue&type=script&lang=js"
import style0 from "./intimateRule.vue?vue&type=style&index=0&id=89a77b68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a77b68",
  null
  
)

export default component.exports